<template>
  <div class="changepassword">
    <div class="navbar">
      <div class="logo">
        <img src="../../assets/imgs/MES-LOGO.png" alt />
      </div>
    </div>
    <div class="center">
      <h1>Change password</h1>
      <el-form
        :model="ChangeForm"
        status-icon
        :rules="rules"
        ref="ChangeForm"
        label-width="100px"
        class="demo-ChangeForm"
      >
        <el-form-item prop="pass">
          <el-input
            type="password"
            v-model="ChangeForm.pass"
            autocomplete="off"
            placeholder="New Password"
          ></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input
            type="password"
            v-model="ChangeForm.checkPass"
            autocomplete="off"
            placeholder="New Password"
          ></el-input>
        </el-form-item>
        <el-button @click="submitForm('ChangeForm')">Comfirm</el-button>
      </el-form>
      <el-link
        @click="$router.push('/login')"
        :underline="false"
        target="_blank"
        class="login"
      >Login</el-link>
    </div>
  </div>
</template>

<script>
import { apiChangePass } from "../../api/userInfo";
//导入抽取的token方法
export default {
  name: "changepass",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please enter your password"));
      } else {
        if (this.ChangeForm.checkPass !== "") {
          this.$refs.ChangeForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please enter your password again"));
      } else if (value !== this.ChangeForm.pass) {
        callback(new Error("Two input password is inconsistent!"));
      } else {
        callback();
      }
    };
    return {
      ChangeForm: {
        pass: "",
        checkPass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      visible: true,
      sign: "",
    };
  },
  mounted() {
    var url = window.location.href;
    console.log(url);
    //如果字符串里面存在?
    if (url.indexOf("?") != -1) {
      //如果存在? 就以等号后面切割开
      var arr = url.split("=");
      console.log(arr);
      //遍历数组
      // for (var i = 0; i < arr.length; i++) {
      //   console.log(arr[i])
      //   // console.log(parameter);
      // }
      this.sign = arr[1];
      console.log(this.sign);
    }
  },
  methods: {
    changePass(value) {
      this.visible = !(value === "show");
    }, //判断渲染，控制按钮的明文和暗文，true:暗文显示，false:明文显示

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apiChangePass({
            userMail: this.sign,
            userPassword: this.ChangeForm.pass,
          }).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              this.$message.success(res.data.message);
              this.$router.push("/login");
            } else {
              this.$message.error(res.data.message);
              return false;
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
.changepassword {
  width: 100%;
  overflow: hidden;
  background-color: #f2f2f2;
  min-height: calc(100vh);
  .navbar {
    height: 55px;
    min-width: 1366px;
    background-color: #fff;
    border-bottom: 1px solid #c8ced3;
    margin: 0 auto;
    overflow: hidden;
    .logo {
      width: 162px;
      height: 40px;
      margin-top: 0px;
      float: left;
      img {
        width: 100%;
      }
    }
  }
  .center {
    height: 332px;
    width: 590px;
    background-color: #fbfbfb;
    margin: 0 auto;
    margin-top: 52px;
    padding: 30px 43px 50px;
    box-sizing: border-box;

    h1 {
      text-align: center;
      color: #333333;
      margin-bottom: 35px;
    }

    .el-input {
      width: 320px;
      position: relative;

      .el-input__inner {
        background-color: #f2f2f2;
        background-image: none;
        border-radius: 0;
        border: 1px solid #cccccc;
      }

      i.el-input__icon.iconfont.icon-xianshi {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 9999;
      }
    }
    .el-button {
      border-radius: 0;
      width: 322px;
      margin-left: 100px;
      background-color: #00b0a6;
      color: white;
      border: none;
      margin-bottom: 30px;
      font-size: 16px;
    }
    .login {
      color: #00b0a6;
      text-align: center;
      height: 20px;
      width: 40px;
      overflow: hidden;
      background-color: #fbfbfb;
      margin-left: 243px;
    }
    .el-link.el-link--default:hover {
      color: #00afa6;
    }
  }
}
</style>